"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var FieldsService =
/*#__PURE__*/
function () {
  function FieldsService(dataset, fields) {
    _classCallCheck(this, FieldsService);

    this.NUMERIC_TYPE = "number";
    this.COLUMN_TYPE = "string";
    this.DATE_TYPE = "date";
    this.dataset = dataset;
    this.fields = fields;
  }

  _createClass(FieldsService, [{
    key: "query",
    value: function query(sql) {
      return fetch("https://api.resourcewatch.org/v1/query/".concat(this.dataset.id, "?sql=").concat(sql)).then(function (response) {
        if (response.status >= 400) throw new Error(response.statusText);
        return response.json();
      }).then(function (jsonData) {
        return jsonData.data;
      });
    }
  }, {
    key: "getTableName",
    value: function getTableName() {
      return this.dataset.attributes.tableName;
    }
  }, {
    key: "getColumnMinAndMax",
    value: function getColumnMinAndMax(field) {
      var columnName = field.columnName;
      var tableName = this.getTableName();
      var query = "SELECT MIN(".concat(columnName, ") AS min, MAX(").concat(columnName, ") AS max FROM ").concat(tableName);
      return this.query(query).then(function (data) {
        return (data === null || data === void 0 ? void 0 : data.length) ? data[0] : {};
      });
    }
  }, {
    key: "getColumnValues",
    value: function getColumnValues(field) {
      var uniq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var columnName = field.columnName;
      var tableName = this.getTableName();
      var uniqQueryPart = uniq ? "GROUP BY ".concat(columnName) : "";
      var query = "SELECT ".concat(columnName, " FROM ").concat(tableName, " ").concat(uniqQueryPart, " ORDER BY ").concat(columnName);
      return this.query(query).then(function (data) {
        return (data !== null && data !== void 0 ? data : []).map(function (d) {
          return d[columnName];
        });
      });
    }
  }, {
    key: "getFieldInfo",
    value: function getFieldInfo(fieldName) {
      var _a, _b;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var field, fieldType, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                field = this.fields.find(function (f) {
                  return f.columnName === fieldName;
                });

                if (field) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", null);

              case 3:
                fieldType = (_b = (_a = constants_1.ALLOWED_FIELD_TYPES.find(function (type) {
                  return type.name === field.type;
                })) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'string';

                if (!(fieldType === this.NUMERIC_TYPE || fieldType === this.DATE_TYPE)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return this.getColumnMinAndMax(field);

              case 7:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 9:
                if (!(fieldType === this.COLUMN_TYPE)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return this.getColumnValues(field);

              case 12:
                _context.t0 = _context.sent;
                return _context.abrupt("return", {
                  values: _context.t0
                });

              case 14:
                return _context.abrupt("return", null);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return FieldsService;
}();

exports["default"] = FieldsService;